import AppEnv from '@/config/config';
import { ASTNode, Kind, OperationDefinitionNode, parse } from 'graphql';
import { request } from 'graphql-request';
import { GraphQLClientRequestHeaders } from 'node_modules/graphql-request/build/esm/types';
import { parseError, UnauthenticatedError } from './handle-error';
import LocalStorage from './local-storage';

const isOperationDefinition = (def: ASTNode): def is OperationDefinitionNode =>
  def.kind === Kind.OPERATION_DEFINITION;

export const fetcher = <TData, TVariables>(
  query: string,
): ((
  variables?: TVariables,
  options?: Record<string, any>,
) => Promise<TData>) => {
  return async (variables?: TVariables) => {
    const token = LocalStorage.getToken();

    const document = parse(query);
    const queryName = document.definitions.find(isOperationDefinition)?.name
      ?.value;

    const headers: GraphQLClientRequestHeaders = {};

    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }

    try {
      return await request({
        url: `${AppEnv.get().apiEndpoint}?${queryName}`,
        document: document,
        variables: variables as any,
        requestHeaders: headers,
      });
    } catch (err) {
      const parsedError = parseError(err);
      if (parsedError instanceof UnauthenticatedError) {
        throw new UnauthenticatedError('Invalid token!');
      }

      throw parsedError;
    }
  };
};
